import LicenseHeader from './container'
export default LicenseHeader
